import React from 'react';

import { createRoot } from 'react-dom/client';

import { getCheck24Namespace } from 'utility/Provide/Namespace/getCheck24Namespace';

import OfferEntry from './OfferEntry';

const { react } = getCheck24Namespace();
const reactRoot = document.createElement('div'); // dummy wrapper container to init our react app
const root = createRoot(reactRoot);

react.register('offers', {
    init: () => {
        root.render(<OfferEntry />);
    },
});
react.init('offers');
